export const LADE_AUSWAHLWERTE_PRAESENZ = "ladeAuswahlwertePraesenz";
